import React from 'react';

import { List, ListItem, Modal, Title } from '@icarros/ids-react';

import { Loading } from '../../../../../components/Loading';
import { pushSellerPFDashboardEvent } from '../../../../../../utils/pushToDataLayer';

import { ListItemModifier, ListModifier, ModalBody } from '../style';
import { ReasonExclusionStepProps } from './types/modal-deactivate';

export function ReasonExclusionStep({
  modalOpen,
  setModalOpen,
  loading,
  selectedRadio,
  handleDelete,
  content,
  setSelectedRadio,
  isDeleteLoading
}: ReasonExclusionStepProps): JSX.Element {
  return (
    <Modal
      stateOpen={[
        modalOpen,
        () => {
          if (modalOpen) {
            pushSellerPFDashboardEvent('voltar', 'modal desativar anúncio - motivo');
          }
          setModalOpen(false);
        }
      ]}
      body={
        <ModalBody>
          {loading && <Loading isInner />}
          <Title variant="default" size="base">
            por que você quer desativar seu anúncio?
          </Title>
          {content && (
            <ListModifier>
              <List>
                {content?.map(({ id, nome }) => (
                  <ListItemModifier key={id}>
                    <ListItem
                      label={nome}
                      variant="selector"
                      radioOnChange={() => setSelectedRadio(id)}
                      radioValue={id}
                      radioChecked={id === selectedRadio}
                      selectorName={nome}
                      selectorVariant="radio"
                      hasLine={false}
                    />
                  </ListItemModifier>
                ))}
              </List>
            </ListModifier>
          )}
        </ModalBody>
      }
      title={'desativar anúncio'}
      mainButtonLoading={isDeleteLoading}
      mainButtonText={'desativar anúncio'}
      mainButtonMethod={() => {
        const selectedOptionString = content?.find(item => item.id === selectedRadio)?.nome;
        pushSellerPFDashboardEvent('desativar anúncio', 'modal desativar anúncio - motivo', {
          opcao_selecionada: selectedOptionString
        });
        handleDelete();
      }}
    />
  );
}
